import { render, staticRenderFns } from "./appDetail.vue?vue&type=template&id=ba969a3e&scoped=true"
import script from "./appDetail.vue?vue&type=script&lang=js"
export * from "./appDetail.vue?vue&type=script&lang=js"
import style0 from "./appDetail.vue?vue&type=style&index=0&id=ba969a3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba969a3e",
  null
  
)

export default component.exports